import { Injectable } from "@angular/core";
import { MenuItem } from "primeng/api";
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: "root"
})
export class StepsService {
    public steps$ = new BehaviorSubject<MenuItem[]>([
        {
          label: "Verfügbarkeit",
          routerLink: "availability-check",
          disabled: false
        },
        {
          label: "Optionen",
          routerLink: "product-options",
          disabled: true
        },
        {
          label: "Daten",
          routerLink: "data-form",
          disabled: true
        },
        {
          label: "Übersicht",
          routerLink: "order-summary",
          disabled: true
        }
      ])

      public enableStep(stepToEnable: string) {
        const steps = this.steps$.getValue()
        const aciveStepIndex = steps.findIndex((step) => step.routerLink === stepToEnable)
        this.steps$.next(steps.map((step, index) => {
          if (index <= aciveStepIndex) {
            return {
              ...step,
              disabled: false
            }
          }
          return {
            ...step,
            disabled: true
          }
        }))
      }

      public getStepByUrl(url: string) {
        return this.steps$.getValue().find((step) => step.routerLink === url)
      }

      public getLastEnabledStepUrl(): string {
        const enabledSteps = this.steps$.getValue()
          .filter((step) => !step.disabled)
        return `/${enabledSteps
        .map((step) => step.routerLink)[enabledSteps.length - 1]}`
      }
}
